import { OrganizationModel, OrganizationStore } from '@journeyapps-platform/lib-journey-core';
import * as accounts from '@journeyapps-platform/types-accounts-hub';
import { makeObservable, observable } from 'mobx';
import { AbstractBatcherBankOptions } from '@journeyapps-platform/lib-journey-core';

export class OrgStore extends OrganizationStore {
  @observable
  current_org?: OrganizationModel;

  constructor(options: AbstractBatcherBankOptions) {
    super(options);
    this.current_org = undefined;
    makeObservable(this);
  }

  async changeOrganization(id: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      // Ensure that if an org is not loaded within 10s that we get redirected
      const timer = setTimeout(() => {
        console.error(`Failed to change to organization with id ${id}, request timed out`);
        resolve(false);
      }, 10000);
      try {
        // TODO: This should fail in AbstractBank and return rather than waiting for ever.
        const org = await this.getOrg(id);
        if (!org) {
          resolve(false);
        }
        this.current_org = org;
        clearTimeout(timer);
        resolve(true);
      } catch (e) {
        console.error(`No organization exists with id ${id}`);
      } finally {
        clearTimeout(timer);
      }
      resolve(false);
    });
  }

  generate(data: accounts.SerializedOrganizationResource): OrganizationModel {
    return new OrganizationModel({
      model: data,
      banks: this.options.banks(),
      clients: this.options.clients
    });
  }

  async loadUserOrgs() {
    const response = await this.options.clients.provisionAccountsV5Client().listOrgs({});
    response.objects.map((res) => this.upsert(res));
  }
}
